import { yellow } from '../yellow';

export const medium = {
  primary: yellow[700],
  500: yellow[500],
  400: 'hsla(45, 100%, 74%, 1)',
  300: 'hsla(45, 100%, 80%, 1)',
  200: 'hsla(45, 100%, 86%, 1)',
  100: yellow[100],
  50: yellow[50],
  30: 'hsla(45, 100%, 94%, 0.5)',
};
